export default __webpack_public_path__ + "static/media/39.11c12c77.png";